import { Box } from "@mui/material";

import {

  // JoinUs,
  OurDoctors,
  OurServices,
  Testimonial,
  Blog,
} from "components";

import { WaveLightInfoSection, HowWaveLightWorks, StepsSection, VisionHeroSection, FaqSection,  Banner, } from "./components";

const WaveLightPlus = () => {
  return (
    <Box>
      <Banner />
      <WaveLightInfoSection />
      <HowWaveLightWorks />
      <StepsSection />
      <VisionHeroSection />
      <FaqSection />
      
     
    </Box>
  );
};

export default WaveLightPlus;
